import { useState } from "react";
import {
  useResourceForecast,
  useDashboardLogic,
  useRelevantProposalsQuery,
  useResourceDetailsQuery,
  ResourceForecastGrid,
  DashboardStats,
  ProposalDetailsModal,
} from "@/features/Dashboard";
import type { Proposal } from "@/features/Dashboard";

export default function DashboardMain() {
  const [selectedProposal, setSelectedProposal] = useState<Proposal | null>(
    null
  );

  // React Query hooks
  const {
    proposals,
    loading: loadingProposals,
    error: proposalsError,
    refetch: refetchProposals,
  } = useRelevantProposalsQuery();

  const {
    getTypeName,
    getTechnologyName,
    loading: loadingDetails,
    error: detailsError,
    refetch: refetchDetails,
  } = useResourceDetailsQuery();

  // Logic hooks
  const dashboardData = useDashboardLogic(proposals);
  const { getProposalByName } = useResourceForecast(proposals);

  console.log("proposalsError:", proposalsError);
  console.log("detailsError:", detailsError);
  
  const loading = loadingProposals || loadingDetails;
  const error = proposalsError || detailsError;

  const handleProposalClick = (proposal: Proposal) => {
    setSelectedProposal(proposal);
  };

  const handleCloseModal = () => {
    setSelectedProposal(null);
  };

  const handleRetry = () => {
    refetchProposals();
    refetchDetails();
  };

  if (loading) {
    return (
      <div className="space-y-8">
        <DashboardStats
          totalResources={0}
          seniorityTotals={{}}
          loading={true}
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-red-800 font-semibold font-montserrat">
              Erro ao carregar dashboard
            </h3>
          </div>
          <button
            onClick={handleRetry}
            className="bg-red-100 hover:bg-red-200 text-red-800 px-4 py-2 rounded-lg font-montserrat font-medium transition-colors"
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <DashboardStats
        totalResources={dashboardData.totalResources}
        seniorityTotals={dashboardData.seniorityTotals}
      />
      <ResourceForecastGrid
        resourceForecast={dashboardData.resourceForecast}
        onProposalClick={handleProposalClick}
        getTypeName={getTypeName}
        getTechnologyName={getTechnologyName}
        getProposalByName={getProposalByName}
      />
      <ProposalDetailsModal
        isOpen={!!selectedProposal}
        proposal={selectedProposal}
        onClose={handleCloseModal}
        getTypeName={getTypeName}
        getTechnologyName={getTechnologyName}
      />
    </div>
  );
}
